import React from 'react';
import { Button } from '@material-ui/core';
import Button2 from '@components/Shared/Buttons/Button';
import Proximo from '@assets/Login/proximo.png';
import { TitlePage} from '@styles/styles.global';
import { PhoneOutlined} from '@mui/icons-material/';

import { Grid, FormControlLabel, Box } from '@material-ui/core';

const Inicial: React.FC = () => {
  const backgroundImage = 'https://www.paieterno.com.br/wp-content/uploads/2025/03/tela-doacao.png';
  const logoClube = 'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/logo-modal.png'

  return (
    <Grid container>
    <Grid container>
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        minHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Conteúdo Central */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
        {/* Imagens */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img
              src={'https://www.paieterno.com.br/wp-content/uploads/2025/03/logo-pai-eterno.png'}
              style={{ width: 120, height: 125, marginTop: '19px' }}
              alt="Logo Pai Eterno"
            />
          <img
            src={'https://www.paieterno.com.br/wp-content/uploads/2025/03/2.png'}
            style={{ width: 200, height: 115 }}
            alt="Imagem 1"
          />

        </div>

        {/* Botões */}
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '45px' }}>
          <Button2 color="secondary" style={{ width: '254px', height: '78px', borderRadius: '25px', marginBottom: '15px', fontSize: '16px',  backgroundColor: '#b80d46', textAlign: 'center' }} onClick={() => { window.location.href = '/doacao-recorrente';}} > <img src={Proximo} style={{ height: 20, width: 20, marginRight: 10}}  />  Faça parte da Família de Amor</Button2>
          <Button2  color="primary" style={{ width: '254px', height: '78px', borderRadius: '25px', marginBottom: '15px', fontSize: '16px', backgroundColor: '#0e4159' }} onClick={() => { window.location.href = '/doacao-unica';}} ><img src={Proximo} style={{ height: 20, width: 20, marginRight: 10}} /> Faça uma doação única</Button2>
          <Button2  color="primary" style={{ width: '254px', height: '78px', borderRadius: '25px', marginBottom: '15px', fontSize: '16px', background: 'linear-gradient(80deg, #8E6CCB, #B084E8)', }} onClick={() => { window.location.href = '/clube-pai-eterno';}} > <img src={logoClube} alt="Ícone" width="200"></img></Button2>
          <Button2  color="tertiary" style={{ width: '254px', height: '78px', borderRadius: '25px', marginBottom: '10px', fontSize: '16px', color: '#0e4159', display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => { window.location.href = '/doacao-internacional';}}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img
                src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/paypal.png'}
                style={{ width: 80, height: 24 }}
                alt="Imagem 2"
              />
              Doação internacional
            </div>
          </Button2>
        </div>

        {/* Botão Voltar */}
        <Button style={{ width: '125px', height: '35px', marginTop: '20px', fontSize: '12px', color:'#0e4159' }}>
          Voltar
        </Button>
      </div>
    </div>
  </Grid>
  {/* --------------------------- RODAPÉ 2 ----------------------------- */}


  <Grid container>
                <Grid container alignItems="center" justify="center" item lg={12} sm={12} xs={12} style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 35 }} >




                <Grid container item lg={7} md={7} sm={7} xs={8} alignItems="center" justifyContent="center">
                  <a href="https://wa.me/556235069800" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <PhoneOutlined style={{ marginTop: 3, height: 17, marginRight: 8, color: '#999' }} />
                    <strong style={{fontSize: 17, color: '#333', textAlign:'center'}}>Central de Relacionamento: </strong>
                    <div style={{ height: '20px' }}></div>
                    <strong style={{textDecoration: 'underline',  textAlign:'center'}}>(62) 3506-9800</strong>
                  </a>
                </Grid>


                </Grid>
              </Grid>

        <Grid item lg={12} sm={12} xs={12} style={{paddingTop: 40}}>
          <Grid container alignItems="center" justify="center"
            style={{backgroundColor: '#fcf7f7', paddingTop: 10, paddingBottom: 10}}
          >
            <Grid container item lg={8} sm={8} xs={12} alignItems="center" justify="center" >
              <TitlePage style={{fontSize: 14, color:'#333'}}>Desenvolvido por  </TitlePage>
              <img src={'https://amex-arquivos.s3.sa-east-1.amazonaws.com/sociallis-logoPng.png'} style={{paddingLeft:10, width: 140 }} />
            </Grid>
          </Grid>
        </Grid>
  </Grid>
  );
};

export default Inicial;
